
import React from "react";
import { SwapRequest } from "@/services/myReagents";
import SwapRequestCard from "./SwapRequestCard";

interface PastRequestsSectionProps {
  requests: SwapRequest[];
  isSentByUser?: boolean;
}

const PastRequestsSection: React.FC<PastRequestsSectionProps> = ({
  requests,
  isSentByUser = false
}) => {
  if (requests.length === 0) return null;

  return (
    <div>
      <h3 className="text-lg font-medium mb-4">
        Past {isSentByUser ? "Sent" : ""} Requests ({requests.length})
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {requests.map((request) => (
          <SwapRequestCard
            key={request.id}
            request={request}
            isPending={false}
            isSentByUser={isSentByUser}
          />
        ))}
      </div>
    </div>
  );
};

export default PastRequestsSection;
